import { render, staticRenderFns } from "./CogneetivPredictNews copy 2.vue?vue&type=template&id=343d3b9a&scoped=true&"
import script from "./CogneetivPredictNews copy 2.vue?vue&type=script&lang=js&"
export * from "./CogneetivPredictNews copy 2.vue?vue&type=script&lang=js&"
import style0 from "./CogneetivPredictNews copy 2.vue?vue&type=style&index=0&id=343d3b9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343d3b9a",
  null
  
)

export default component.exports